import map from "lodash/map";
import get from "lodash/get";

export const getGatewayDeviceHierarchy = (data, orphanDevices = []) => {
  // console.log("enter here");
  data = map(data, (node) => ({
    id: get(node, "id"),
    label: get(node, "name"),
    value: `${get(node, "gatewayType.name")}@${get(node, "id")}@${get(
      node,
      "gatewayUuid"
    )}`,
    key: `${get(node, "gatewayType.name")}@${get(node, "id")}@${get(
      node,
      "gatewayUuid"
    )}`,
    type: get(node, "gatewayType.name"),
    children: get(node, "hasDeviceConnectivity")
      ? map(get(node, "deviceEntityVOS"), (device) => ({
          id: get(device, "id"),
          label: get(device, "name"),
          value: `DEVICE@${get(device, "id")}@${get(device, "uuid")}`,
          key: `DEVICE@${get(device, "id")}@${get(device, "uuid")}`,
        }))
      : getGatewayDeviceHierarchy(get(node, "subGatewayVOS")),
  }));

  map(orphanDevices, (device) => {
    data.push({
      id: get(device, "id"),
      label: get(device, "name"),
      value: `DEVICE@${get(device, "id")}@${get(device, "uuid")}`,
      key: `DEVICE@${get(device, "id")}@${get(device, "uuid")}`,
    });
  });
  // console.log("#######", { data, orphanDevices });
  return data;
};
